export default __webpack_public_path__ + "static/media/Monger-HUD-Pop-Up (Process).85f83ebb.jpg";